exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#html5-qrcode-button-camera-permission.html5-qrcode-element,#html5-qrcode-button-camera-start.html5-qrcode-element,#html5-qrcode-button-camera-stop.html5-qrcode-element,#html5-qrcode-select-camera.html5-qrcode-element{border-bottom:1px solid!important;margin:6px 0!important}", ""]);

// exports
